export const shareableLink = (): string => {
  const shareableUrl = new URL(window.location.href);

  shareableUrl.searchParams.set("utm_source", "OneFootball_CW");
  shareableUrl.searchParams.set("utm_medium", "website");
  shareableUrl.searchParams.set("utm_campaign", "NativeShare");

  return shareableUrl.href;
};
